<script setup lang="ts">
import { ref, computed } from "vue";
import { defineEmits, defineProps } from "vue";
import { useRoute } from "vue-router";
const props = defineProps<{
  drawer: boolean;
  isMobile: boolean;
  theme: string;
  userProfile: {
    role: "user" | "admin";
    [key: string]: any;
  };
}>();
const route = useRoute();
const emit = defineEmits<{
  (e: "update:drawer", value: boolean): void;
  (e: "logout"): void;
}>();

const isHovered = ref(false);

const customerMenu = ref([
  { title: "Inicio", value: "/", icon: "mdi-view-dashboard" },
  { title: "Mis equipos", value: "/devices", icon: "mdi-broadcast" },
  { title: "Reportes", value: "/reports", icon: "mdi-poll" },
]);

const managerMenu = ref([
    { title: "Inicio", value: "/", icon: "mdi-view-dashboard" },    
  { title: "Equipos", value: "/manager-devices", icon: "mdi-broadcast" },
  { title: "Mediciones", value: "/device-samples", icon: "mdi-ruler" },
    { title: "Compañias", value: "/companies", icon: "mdi-domain" },
  { title: "Clientes", value: "/customers", icon: "mdi-account-group" },
  { title: "Colaboradores", value: "/teams", icon: "mdi-account-hard-hat" },
  // { title: 'Ajutes', value: '/settings', icon: 'mdi-toggle-switch-outline' },
  { title: "Estado", value: "/status", icon: "mdi-list-status" },
]);

const railWidth = 70;

const onMouseEnter = () => {
  if (!props.isMobile) {
    isHovered.value = true;
  }
};

const onMouseLeave = () => {
  isHovered.value = false;
};

const expandedDrawer = computed(() => {
  return props.drawer || isHovered.value;
});
const drawerColor = computed(() => {
  return props.theme === "myCustomDarkTheme" ? "#1e1e2d" : "#f5f5f5";
});

const railEnabled = computed(() => {
  return !props.isMobile && !expandedDrawer.value;
});

const currentMenu = computed(() => {
  const role = props.userProfile?.role;
  return role === "admin" ? managerMenu.value : customerMenu.value;
});

const showAdminSection = computed(() => {
  return props.userProfile?.role === "admin";
});
</script>

<template>
  <v-navigation-drawer
    class="sidebar bg-background"
    :model-value="true"
    :rail="railEnabled"
    :rail-width="railWidth"
    :width="260"
    :permanent="true"
    :temporary="props.isMobile"
    :location="props.isMobile ? 'bottom' : 'left'"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div class="pa-4 d-flex align-center">
      <v-avatar
        size="44"
        class="d-flex align-center justify-center text-center"
      >
        <v-img class="py-2" src="/isowipi.svg"></v-img>
      </v-avatar>

      <v-img v-if="expandedDrawer" height="50" src="/textwipi.svg"></v-img>
    </div>

    <v-list v-if="!showAdminSection" class="pa-2">
      <v-list-item
        v-for="(item, i) in currentMenu"
        :key="i"
        :value="item.value"
        :title="expandedDrawer ? item.title : ''"
        :prepend-icon="item.icon"
        :to="item.value"
        :active="route.path === item.value"
        :class="{ 'rounded-lg': true, 'mb-1': true }"
        link
        @click="props.isMobile ? emit('update:drawer', false) : null"
      ></v-list-item>
    </v-list>

    <v-divider v-if="showAdminSection" class="mx-4 my-2"></v-divider>

    <div
      v-if="expandedDrawer && showAdminSection"
      class="text-caption px-4 text-grey py-2"
    >
      Administración
    </div>

    <v-list v-if="showAdminSection" class="pa-2">
      <v-list-item
        v-for="(item, i) in managerMenu"
        :key="i"
        :value="item.value"
        :title="expandedDrawer ? item.title : ''"
        :prepend-icon="item.icon"
        :active="route.path === item.value"
        :class="{ 'rounded-lg': true, 'mb-1': true }"
        :to="item.value"
        link
        @click="props.isMobile ? emit('update:drawer', false) : null"
      ></v-list-item>
    </v-list>

    <template v-if="expandedDrawer" v-slot:append>
      <div class="pa-2">
        <v-btn block @click="emit('logout')" variant="text" color="error">Cerrar sesión</v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<style scoped>
.sidebar {
  transition: width 0.3s ease;
}

.v-list-item--active {
  background-color: #7367f0 !important;
  color: white !important;
}

.v-list-item .v-list-item__append {
  font-size: 20px;
}
</style>
